import { BoxV2 as Box } from 'portal-commons';
import { FunctionComponent } from 'react';
import { faCircleX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface RemoveButtonProps {
  onClick?: () => void;
}

const RemoveButton: FunctionComponent<RemoveButtonProps> = ({ onClick }) => (
  <Box
    sx={{
      color: 't.black60',
      fontWeight: 400,
      fontSize: 'H500',
      lineHeight: 'normal',
      cursor: 'pointer',
    }}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faCircleX} />
  </Box>
);

export default RemoveButton;
